import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { BREADCRUMB_ENTRIES, type BreadcrumbIcon } from "../Config/BreadcrumbConfig";

const renderIcon = ({ src, Icon, alt, className, style }: BreadcrumbIcon) =>
  Icon ? (
    <Icon className={className} style={style} />
  ) : (
    <img src={src} alt={alt} className={className} style={style} />
  );

const PageBreadcrumb: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const entry = BREADCRUMB_ENTRIES.find(
    item => item.paths?.includes(pathname) || item.matches?.(pathname)
  );

  if (!entry) {
    return null;
  }

  const { lead, leadLabelKey, prefix, trail, trailGap, title } = entry;
  const PrefixTag = prefix?.tag;

  return (
    <>
      {renderIcon(lead)}
      {leadLabelKey && t(leadLabelKey)}
      {PrefixTag && prefix && (
        <PrefixTag className="dashboard-prefix">
          {`${prefix.before}${t(prefix.textKey)}${prefix.after}`}
        </PrefixTag>
      )}
      {trail && renderIcon(trail)}
      {trailGap && " "}
      {title && (
        <p className={title.className}>{`${title.before}${t(title.textKey)}${title.after}`}</p>
      )}
    </>
  );
};

export default PageBreadcrumb;
